import React, { useEffect, useState } from "react";

const OfficeMappingDataView = ({ data }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    setDetails({
      ShippingAddressLatitude: [
        "Shipping Business Latitude",
        data.shippingAddressLatitude,
      ],
      ShippingLastVerified: [
        "Shipping Last Verified",
        data.shippingLastVerified
          ? new Date(data.shippingLastVerified).toLocaleDateString() +
            " " +
            new Date(data.shippingLastVerified).toLocaleTimeString(
              navigator.language,
              { hour: "2-digit", minute: "2-digit" }
            )
          : data.shippingLastVerified,
      ],
      ShippingAddressLongitude: [
        "Shipping Address Longitude",
        data.shippingAddressLongitude,
      ],
      ShippingReturnCode: ["Shipping Return Code", data.shippingReturnCode],
      Geolocation: ["Geolocation", data.geolocation],
      ShippingCountry: ["Shipping County", data.shippingCounty],
      ShippingTimeZone: ["Shipping Time Zone", data.shippingTimeZone],
      ShippingDaylightSavings: [
        "Shipping Daylight Savings",
        data.shippingDaylightSavings ? "True" : "False",
      ],
    });
  }, []);

  return (
    <div className="w-full">
      <div className="grid text-xs px-9  py-2  gap-y-1 md:grid-cols-2">
        {Object.values(details).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-2 ">
                <div className="expandedLabel fontExpand text-left">
                  <span className="">{item[0]}:</span>
                </div>
                <span className="expandedData fontExpand -ml-4">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>{" "}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeMappingDataView;
